import { Gender } from "../enums/gender";

export const translatedGenderTypes = [
    {
        name: 'Masculino',
        value: Gender.Male,
    },
    {
        name: 'Feminino',
        value: Gender.Female
    }
]